package com.nonopn.skydome.common.app.navigation

import eu.codlab.navigation.RouteParameterTo

object PossibleRoutes {
    val entries = listOf(
        // New UX routes (Phase 0)
        RouterDashboard,
        RouterActivity,
        RouterProjects,
        RouterDocuments,
        RouterAccount,
        RouterProbes,
        RouterProbeCreate,
        RouterSettings,
        // Legacy routes (preserved for admin)
        RouterMap,
        RouterMapAdmin,
        RouterLightningCertificatesAdmin,
        RouterLightningCertificatesNormal,
        RouterLightningDensitiesAdmin,
        RouterLightningDensitiesNormal,
        RouterEstimates,
        RouterEstimateNewAdmin,
        RouterEstimateNew,
        RouterEstimateExistingAdmin,
        RouterEstimateExisting,
        RouterEstimatesAdmin,
        // Promotion codes (administrator mode)
        RouterPromotionCodesAdmin,
        RouterPromotionCodeEditAdmin,
        // Phase 2 — Keraunic report & certificate routes
        RouterKeraunicReport,
        RouterCertNsg,
        RouterCertFoudr,
        // Phase 3 — External sharing Strike Radar
        RouterConsultation,
    )

    fun defaultFromUrlLaunched(path: String): RouteParameterTo =
        (entries.firstOrNull { it.isMatching(path) } ?: RouterDashboard).navigateFrom(path)
}
